export function ownerContactFromIndex(owner, index, firstNames = []) {
    if (owner.contact_surname) return null;

    const titleCase = value => value.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

    for (const record of index || []) {
        const name = record?.owner_name?.trim();
        if (!name || /registered|estate|the$|proprietor|P\/L/i.test(name)) continue;

        const match = name.match(/^([A-Za-z -]+),\s*([A-Za-z]+)(?:\s+([A-Z]))?/);
        if (!match || !match[1].trim() || match[2].toLowerCase() === "the") continue;

        const surname = titleCase(match[1].trim());
        const firstName = titleCase(match[2]);
        const middleInitial = match[3] || null;
        const confirmed = window.confirm(
            `This owner has no contact currently, would you like to add first name: ${firstName}${middleInitial ? ", middle initial: " + middleInitial : ""}, surname: ${surname} as a contact?`
        );
        if (!confirmed) continue;

        const matchingFirstName = (firstNames || []).find(({ first_name }) => first_name === match[2]);
        const contact = {
            contact_surname: surname,
            contact_first_name: matchingFirstName ? match[2] : firstName,
            contact_middle_initial: middleInitial,
        };

        if (matchingFirstName) {
            const salutation = matchingFirstName.gender === "M" ? "Mr" : matchingFirstName.gender === "F" ? "Ms" : null;
            contact.contact_salutation = salutation;
            contact.selectedSalutation = { value: salutation, label: salutation };
        }

        return contact;
    }

    return null;
}